import { render, staticRenderFns } from "./ConfigurazioniMagazzinoFornitoriListComponent.vue?vue&type=template&id=1432de44"
import script from "./ConfigurazioniMagazzinoFornitoriListComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurazioniMagazzinoFornitoriListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports